import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=636ee22e&scoped=true&"
import script from "./tenant.vue?vue&type=script&lang=js&"
export * from "./tenant.vue?vue&type=script&lang=js&"
import style0 from "./tenant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tenant.vue?vue&type=style&index=1&id=636ee22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ee22e",
  null
  
)

export default component.exports